// es2015 module
import Vue from 'vue';
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);
